import { useEffect, useRef } from 'react';

import { Environment } from '@/src/environment';
import { logger } from '@/src/internal/logger';

import { useClientEnvironment } from './useClientEnvironment';

/**
 * A hook that logs application diagnostic information to the console.
 */
export const useApplicationDiagnostics = () => {
  const { env, isReady } = useClientEnvironment();

  const versionLogged = useRef<null | string>(null);

  useEffect(() => {
    const logTestEnvWarning = (context?: Record<string, unknown>) => {
      logger.error(
        'The useApplicationDiagnostics hook should not be used in a test environment, as it ' +
          'may cause unnecessary initialization of internal state and refs. Are you using ' +
          'the "MockApplicationConfig" component in your tests?',
        { ...context, NODE_ENV: process.env.NODE_ENV },
      );
    };

    if (process.env.NODE_ENV === 'test') {
      return logTestEnvWarning();
    }
    if (!isReady) {
      return;
    }
    if (
      !versionLogged.current &&
      env.deploymentEnv !== Environment.Test &&
      env.appVersion?.trim()
    ) {
      /* eslint-disable-next-line no-console */
      console.log(
        `Version: ${env.appVersion}`,
        process.env.NEXT_PUBLIC_COMMIT_SHA ? `Commit: ${process.env.NEXT_PUBLIC_COMMIT_SHA}` : '',
      );
      versionLogged.current = env.appVersion;
    }
  }, [isReady, env]);
};
